
import { defineComponent } from 'vue';
import RegistrationAgent from './RegistrationAgent.vue';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import { mapGetters } from 'vuex';
import config from '@/shared/constants/config';

let competitions = [
  {
    id: 'agent-competition-2022-dell',
    image: '/img/monitor-dell-win.webp',
    termsUrl: config.COMPETITION_TERMS_AGENT_URL,
  },
  {
    id: 'agent-competition-2022-jbl',
    image: '/img/monitor-jbl-win.webp',
    termsUrl: config.COMPETITION_TERMS_AGENT_URL2,
  },
];

export default defineComponent({
  components: {
    RegistrationAgent,
    ResizableImage,
  },
  data() {
    return {
      logoUrl: config.BASE_URL + '/img/logo.svg',
      domain: config.DOMAIN,
      competition: null,
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    uniqueClass() {
      return 'competition-' + this.competition.id;
    },
  },
  created() {
    let id = this.$route.query.id as string;

    if (id) {
      this.competition = competitions.find((x) => x.id.toLowerCase() === id.toLowerCase());
    }

    if (!this.competition) {
      this.competition = competitions[0];
    }

    if (this.isLoggedIn) {
      this.$router.push({ name: 'AdFormCreate' });
    }
  },
});
